var lists_default = {
  "fontElementMap": "eBHP9",
  "orderedlist": "XA-97",
  "bulletedlist": "-nqKC",
  "listItem": "q1Z-x"
};
export {
  lists_default as default
};
//# sourceMappingURL=lists-scss.js.map
